import styled from 'styled-components'

export const DeltaContainer = styled.span<{ delta: number }>`
  color: ${({ delta }) => (delta >= 0 ? 'green' : 'red')};
`
